/** Bir SVG elemanını PNG veri URL'sine çevirir (canvas). Tarayıcı gerektirir. */
export function svgToPng(svg: SVGSVGElement, scale = 2): Promise<{ dataUrl: string; width: number; height: number }> {
  const vb = svg.viewBox.baseVal;
  const width = Math.round((vb.width || svg.clientWidth || 640) * scale), height = Math.round((vb.height || svg.clientHeight || 400) * scale);
  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute("width", String(width)); clone.setAttribute("height", String(height));
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  // Tailwind sınıfları PNG'ye taşınmaz: metin boyutu/rengi satır içine yaz
  clone.querySelectorAll("text").forEach((t) => { t.setAttribute("font-size", "10"); t.setAttribute("font-family", "JetBrains Mono, monospace"); if (!t.getAttribute("fill")) t.setAttribute("fill", "#374151"); });
  const blob = new Blob([new XMLSerializer().serializeToString(clone)], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas"); canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext("2d"); if (!ctx) { reject(new Error("Canvas yok")); return; }
      ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, width, height); ctx.drawImage(img, 0, 0, width, height);
      URL.revokeObjectURL(url);
      resolve({ dataUrl: canvas.toDataURL("image/png"), width, height });
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("SVG görüntüye çevrilemedi")); };
    img.src = url;
  });
}

export function dataUrlToBytes(dataUrl: string): Uint8Array {
  const b64 = dataUrl.slice(dataUrl.indexOf(",") + 1);
  const bin = atob(b64); const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
